import { Carrier, Port, Route, Vessel } from './../';
import { Voyage } from './voyage';
import { Schedule } from '../../index';

export class Voyages {

  public searchId: string;
  public total: number;

  public items: Array<Voyage>;

  public carriers: Array<{ count: number, minDuration: number, maxDuration: number, selected: boolean, carrier: Carrier }>;
  public selectedCarriers: Array<number>;
  public excludedCarriers: Array<number>;

  public accountTypeStr: string = '';

  constructor(json: any, accountType = '') {
    try {
      let summary = json.data.summary;
      let data = json.data;

      this.searchId = data.searchId;
      this.total = summary.count;

      this.accountTypeStr = accountType;

      this.setItems(data.items, accountType);
      this.setCarriers(summary);
    } catch (ex) {
      this.setDefaults();
    }
  }

  setDefaults() {
    this.searchId = '';
    this.total = 0;

    this.items = [];

    this.selectedCarriers = [];
    this.excludedCarriers = [];
  }

  setItems(items: Array<any>, accountType: string) {
    let show = this.accountTypeStr !== '' && this.accountTypeStr !== 'Basic';

    this.items = [];
    let voyages = new Array<string>();

    for (let current = 0; current < items.length; current++) {
      try {
        let item = items[current];
        let index = voyages.indexOf(item.schedule_id);

        if (index < 0) {

          // ****
          if (item.route === undefined) {
            item.route = new Route(null);
          }
          if (item.route.name === undefined) {
            item.route.name = 'Undefined route name';
          }
          item.route.name = show ? item.route.name : 'blurred text';
          // ****

          this.items.push(new Voyage(item));
          voyages.push(item.schedule_id);
        } else {
          this.items[index].addSchedule(new Schedule(item));
        }
      } catch (ex) {
        // console.log('exception in voyages setItems', ex);
      }
    }
  }

  setCarriers(summary: any) {
    this.carriers = [];
    this.selectedCarriers = summary.selected_carriers;
    this.excludedCarriers = summary.excluded_carriers;

    let available = summary.available_carriers;
    let selected = summary.selected_carriers;
    let excluded = summary.excluded_carriers;

    for (let current = 0; current < available.length; current++) {
      let carrier = new Carrier(available[current].carrier);
      let count = available[current].count;
      let min = available[current].min_duration;
      let max = available[current].max_duration;
      let isSelected = this.isCarrierSelected(carrier.id, selected, excluded);

      this.carriers.push({ count: count, minDuration: min, maxDuration: max, selected: isSelected, carrier: carrier });
    }
  }

  isCarrierSelected(carrierId: Number, selected: Array<Number>, excluded: Array<Number>): boolean {
    if (selected.length === 0 && excluded.length === 0) {
      return true;
    }

    // excluded
    if (excluded.indexOf(carrierId) > -1) {
      return false;
    }

    // selected and not excluded
    if (selected.indexOf(carrierId) > -1) {
      return true;
    }

    // not selected
    if (selected.length !== 0) {
      return false;
    }

    // not excluded
    return true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/voyage-models/voyages.ts